const state = {
  showPinchIn: false,
  pinchInParams: {}
}

const getters = {
  showPinchIn(state) {
    return state.showPinchIn
  },
  pinchInParams(state) {
    return state.pinchInParams
  }
}

const actions = {
  setShowPinchIn({commit}, showPinchIn) {
    commit('setShowPinchIn', showPinchIn)
  },
  setPinchInParams({commit}, pinchInParams) {
    commit('setPinchInParams', pinchInParams)
  }
}

const mutations = {
  setShowPinchIn(state, showPinchIn) {
    state.showPinchIn = showPinchIn
  },
  setPinchInParams(state, pinchInParams) {
    state.pinchInParams = pinchInParams
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/pinchinData.js